<template>
  <v-layout>
    <v-flex xs12 sm12>
      <v-card>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar
              color="accent"
              size="48">
              <span class="white--text headline">{{_avatar}}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{_user.username}}</v-list-tile-title>
              <v-list-tile-sub-title>{{_user.email}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <template v-if="_managers.length > 0">
          <v-list two-line>
            <v-subheader>{{_managers.length === 1 ? 'Ваш менеджер': 'Ваши менеджеры'}}</v-subheader>
            <v-list-tile v-for="manager in _managers" :key="manager.name">
              <v-list-tile-content>
                <v-list-tile-title>{{manager.name}}</v-list-tile-title>
                <v-list-tile-sub-title v-if="manager.phone">
                  <v-icon small>mdi-phone</v-icon>
                  <a :href="`tel:${manager.phone}`">{{manager.phone}}</a>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="manager.skype">
                  <v-icon small>mdi-skype</v-icon>
                  <a :href="`skype:${manager.skype}?chat`">{{manager.skype}}</a>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
        </template>
        <v-card-actions>
          <v-btn flat color="accent" :to="{name: 'profile'}">Настройки</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat color="accent" @click="logout">Выйти</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'user-menu',

  computed: {
    ...mapGetters('user', {
      _user: 'user',
      _managers: 'managers',
      _avatar: 'avatar'
    })
  },

  methods: {
    logout () {
      this._logout()
      this.$router.push({ name: 'login' })
    },
    ...mapActions('auth', {
      _logout: 'logout'
    })
  }
}
</script>

<style scoped>

</style>
